/*
 * Hotelrez
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
   * @memberOf module:bs_114
   * @see {@link prestart}
   *
   * @param {object} ctx - The context object.
   */
  engine.boot = function boot() {

    // Detect the change of language via dataLayer event (it can't be done via HTML observer)
    if (!thn.hotelrezLanguageDatalayer) {
      thn.hotelrezLanguageDatalayer = new thn.DataLayerHelper(window.dataLayer, function (model, message) {

        if (message.event === 'language') {
          thn.languageCheck().then(function ({ changed }) {
            if (!changed) {
              thn.pageCheck();
            }
          });
        }
      }, true);

      thn.shutdown(function () {
        thn.hotelrezLanguageDatalayer.cancel();
        delete thn.hotelrezLanguageDatalayer;
      });
    }
  };

  /**
   * @memberOf module:bs_114
   * @see {@link generate_search_url}
   *
   * @param {object} ctx - The context object.
   */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    // https://bookings.hotelrez.co.uk/?adult=2&arrive=2023-11-22&chain=30876&child=0&currency=GBP&depart=2023-11-24&hotel=41725&level=hotel&locale=en-US&promo=EXCLUSIVE&rooms=1
    const url = new URL(ctx.baseUrl);
    const validUrl = url.hostname.includes('bookings');

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }
    ctx.newUrl = url.toString();
    return ctx;
  };

  /**
     * @memberOf module:bs_114
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = function onStateChange(ctx) {
    thn.logger.debug('------- Page Check -------');
    // Give some time to the page to load (R&R and BC)
    setTimeout(thn.pageCheck, 800);
  };

  /**
     * @memberOf module:bs_114
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {
    // This implementation neither allows to add children or multiple rooms
    var widgetData = {};
    const isSpinnerInRooms = !!document.querySelector('.spinner_main');

    // End execution if there's no rooms
    if (document.querySelector('.product-availability-container_unavailableMessage')) {
      this.logger.debug('------- No rooms available -------');
      widgetData.noRooms = true;
      return widgetData;
    }

    const _globalTracking = window._globalTracking;

    widgetData.dateBegin = _globalTracking.ArrivalDtYYYYMMDD || thn.dateToString((document.querySelector('.reservation-cart-container_dates span:nth-child(1)') || {}).textContent || '');
    widgetData.dateEnd = _globalTracking.DepartDtYYYYMMDD || thn.dateToString((document.querySelector('.reservation-cart-container_dates span:nth-child(2)') || {}).textContent || '');

    widgetData.rooms = 1;

    widgetData.adults = parseInt((document.querySelector('.reservation-cart-container_guests span') || {}).textContent || '2', 10);
    widgetData.children = 0;
    widgetData.guests = widgetData.adults;

    const pricesRaw = Array.from(document.querySelectorAll('.thumb-cards_price span') || {}).map(function (el) {
      return thn.parseNumber(el.textContent || '');
    });

    // Filter empty elements of the Array
    const prices = pricesRaw.filter((el) => el != null);

    if (prices.length) {
      widgetData.price = Math.min(...prices);
      widgetData.currency = _globalTracking.SelectedCurrCode || thn.getCurrencyCode((((document.querySelector('.thumb-cards_price span') || {}).textContent || '').match(/[^\d\s]/) || {})[0] || '$');
      widgetData.set = true;
    } else if (!isSpinnerInRooms) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_114
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {
    // Store elements to observe
    // const rooms_wrapper = document.querySelector('#auto-parent-card-0');
    const roomsWrapper = document.querySelector('#mainContent');

    // Reload script when the BE finished searching rooms
    if (!thn.empty(roomsWrapper) && !thn.townhouseMykonosSearchRoomsObserver) {
      thn.townhouseMykonosSearchRoomsObserver = thn.debounce(function () {

        // Ensure that is not loading and is in the pathname is the R&R one
        if (!document.querySelector('.spinner_container') && window.location.pathname.match(/^\/$/)) {
          ctx.widget.logger.debug('------- Update Price Widget -------');
          ctx.widget.refresh();
        }
      }, 600);

      // Start observation
      thn.observeDom(roomsWrapper, thn.townhouseMykonosSearchRoomsObserver, {
        childList: true,
        subtree: true,
        characterData: false,
        attributes: false,
      });

      thn.pageUnload(function () {
        thn.stopObserveDom(roomsWrapper, thn.townhouseMykonosSearchRoomsObserver);
        delete thn.townhouseMykonosSearchRoomsObserver;
      });
    }

  };

  /**
     * @memberOf module:bs_114
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    var widgetData = {};
    var _GlobalTokens = window._GlobalTokens;

    if (_GlobalTokens) {
      widgetData.price = _GlobalTokens.TotalCostWithTax;
      widgetData.currency = _GlobalTokens.CurrCode;
      widgetData.dateBegin = _GlobalTokens.ArrivalDtYYYYMMDD && _GlobalTokens.ArrivalDtYYYYMMDD.replace(/-/g, '/');
      widgetData.dateEnd = _GlobalTokens.DepartDtYYYYMMDD && _GlobalTokens.DepartDtYYYYMMDD.replace(/-/g, '/');
      widgetData.bookingId = ((document.querySelector('.confirmation-message_confirmationNumber') || {}).textContent || '').trim();
    }

    return widgetData;
  };

  /**
   * @memberOf module:bs_114
   * @this thn.widgets.price
   * @see {@link Price#get_promocode}
   *
   * @param {object} ctx - The context object.
   */
  engine.getPromocode = function getPromocode(ctx) {
    const promo = thn.parseUrlParameter('promo');
    ctx.promocode = promo || '';
    return ctx.promocode;
  };

  return engine;

}

export { factory };
